// Billet temperature → SVG <linearGradient> id.
// Steel hot-rolling working window is roughly 800–1200 °C. We bucket into
// 4 gradients so the visual maps consistently (cool, warm, hot, incandescent)
// without needing to interpolate gradient stops at runtime.
// Gradient ids are defined in <TempGradients/> as SVG <defs>.

export const TEMP_GRADIENT_IDS = {
	cool: "visualizer-temp-cool",
	warm: "visualizer-temp-warm",
	hot: "visualizer-temp-hot",
	incandescent: "visualizer-temp-incandescent",
} as const;

export const tempToGradientId = (tempC: number): string => {
	if (tempC < 700) return TEMP_GRADIENT_IDS.cool;
	if (tempC < 950) return TEMP_GRADIENT_IDS.warm;
	if (tempC < 1100) return TEMP_GRADIENT_IDS.hot;
	return TEMP_GRADIENT_IDS.incandescent;
};

// Solid colour for KPI temperature labels (text colour code).
export const tempToTextColor = (tempC: number): string => {
	if (tempC < 700) return "#94a3b8"; // slate
	if (tempC < 950) return "#f59e0b"; // amber
	if (tempC < 1100) return "#ea580c"; // orange-600
	return "#dc2626"; // red-600 (incandescent)
};
